import React, { Component } from 'react';
import { urlApi } from '../Constants/Global';
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap';
import parse from 'html-react-parser';
import Bg from '../Images/bg/bg-gs.png';

export class SectionService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalTitle: '',
      modalImage: '',
      modalMessage: '',
      modalShow: false,
      modalGallery: ''
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleClose() {
    this.setState({ modalShow: false });
  }

  handleShow() {
    this.setState({ modalShow: true });
  }

  viewMore(v_item) {
    console.log(v_item);
    this.setState({
      modalTitle: v_item.set1,
      modalMessage: v_item.set3,
      modalGallery: v_item.set4
    });
    this.handleShow();
  }

  render() {
    return (
      <>
        <section className="section section-service" id="service" style={{ backgroundImage: 'url(' + Bg + ')', backgroundRepeat: 'no-repeat', backgroundSize: '40rem', backgroundPosition: '-40px -20px' }}>
          <Container>
            <h2 className="font-header mb-4">SERVICES</h2>
            <Row>
              {this.props.contents.map((item, index) => (
                <Col md={6} lg={3} className="p-0" key={index} onClick={() => this.viewMore(item)}>
                  <Card className="border-0 rounded-0">
                    <Card.Body className="text-center p-4">
                      <img src={urlApi + '/storage/media/' + item.set2} alt='service icon' className="mb-3" style={{ width: '120px' }} />
                      <h5>{item.set1}</h5>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Modal show={this.state.modalShow} onHide={this.handleClose} fullscreen={true}>
          <Modal.Header closeButton>
            <Modal.Title className="itx-primary text-center w-100">{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="itx-dark p-5" scrollable={true}>
            <Container>
              <Row className="mb-3 fs-5">
                <Col sm={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} className="tx-service-modal">
                  {this.state.modalMessage ? parse(this.state.modalMessage) : ''}
                </Col>
              </Row>
              <Row className="mb-5">
                <Col sm={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} className="text-center">
                  <div className="ict-img-100">
                    {this.state.modalGallery ? parse(this.state.modalGallery) : ''}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button className="btn btn-sm ibt-primary px-3" onClick={this.handleClose}>กลับสู่หน้าหลัก</Button>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

SectionService.defaultProps = {
  contents: []
}

export default SectionService